export default {"src":"/_next/static/media/flag-UY.e81d7c08.svg","height":17,"width":24,"blurWidth":0,"blurHeight":0};